import { z } from 'zod';
import { LanguageSchema } from '../common/language.js';
import { phoneE164Field } from '../common/phone.js';
import { IanaZoneSchema } from '../common/zone.js';
// Request schema for PATCH /api/auth/me/profile.
//
// Split into its own module (beside auth/requests.ts) so the phone validator
// (libphonenumber-js/max bundled metadata) loads ONLY where a phone field is
// actually edited. The login / MFA / change-password forms import the phone-free
// `auth/requests` and never pull libphonenumber into their lazy chunk. Per
// CONVENTIONS §Schemas — a module may split a sub-schema into its own file when
// import-isolation demands it.
//
// Partial body, all fields optional; the server mutates only fields present.
// `phone_e164` is nullable so the user can explicitly clear it (passing `null`);
// omitting it leaves the stored value untouched. `phoneE164Field` (common/phone)
// is the single source of truth shared with the admin user-create path — both
// write `users.phone_e164`, validated as a canonical E.164 (ADR-035).
export const PatchProfileRequestSchema = z
    .object({
    first_name: z.string().trim().min(1).max(64).optional(),
    last_name: z.string().trim().min(1).max(64).optional(),
    email: z.string().trim().email().max(128).optional(),
    phone_e164: phoneE164Field,
    theme_mode: z.enum(['light', 'dark', 'system']).optional(),
    language: LanguageSchema.optional(),
    // The person's zone (ADR-082 §3) — the one zone check; never null, a person always has one.
    timezone_iana: IanaZoneSchema.optional(),
})
    .strict()
    .superRefine((v, ctx) => {
    if (Object.keys(v).length === 0) {
        ctx.addIssue({ code: 'custom', message: 'at least one field required' });
    }
});
